import * as React from "react";
import DeviceContext from "../../../service/indentifyDevice";
import Tag from "../../../generic/tag";
import OverflowButton from "../../../generic/overflowButton";
import ObCheckbox from "../../orderBook/generic/obCheckbox";
import { toINR } from "../../../service/numberFormat";
import { IListObj } from "../../../types/genericTypes";
import { IPosition } from "../../../types/components/positions/posTypes";

export interface IPositionTblRowDeskProps {
	data: IPosition;
	isAccordianOpen: boolean;
	isSelectEnable: boolean;
	toggleTab: (e: React.MouseEvent<HTMLLIElement, MouseEvent>) => void;
	onSelect: () => void;
}

const dropdownOptions: Array<IListObj> = [
	{ value: "sqoff", display: "Sq. Off" },
	{ value: "add", display: "Add" }
];

const PositionTblRowDesk: React.FC<IPositionTblRowDeskProps> = (props) => {
	const handleDevice = DeviceContext();

	return (
		<li onClick={props.toggleTab} className={"panel_row" + (props.isAccordianOpen ? " active" : "")}>
			<div>
				{/* according to condition need  to show checkbox. */}
				{props.isSelectEnable && (
					<div className="col chkbx">
						<ObCheckbox
							name="eqTradeSelect"
							checked={props.data.isSelected}
							onChange={() => {
								props.onSelect();
							}}
						/>
					</div>
				)}
				<div className="col symb">
					<p className="symb_nm robM" dangerouslySetInnerHTML={{ __html: props.data.name }} />
					<p className="sym_code">{props.data.trdSym}</p>
				</div>
				<div className="col ltp">
					<p>{toINR(props.data.ltp, 2)}</p>
				</div>
				<div className="col prod_typ">
					<p>{props.data.prdCode}</p>
				</div>
				<div className="col net_qty taRight">
					<p className="qty robM">{props.data.ntQty}</p>
					<p className="sym_code">
						@ <span className="rupy">₹</span>
						{toINR(props.data.trsTyp === "B" ? props.data.avgByPrc : props.data.avgSlPrc, 2)}
					</p>
				</div>
				<div className={"col unrlzd robM taRight " + (+props.data.urlzPL > 0 ? "kelly_green" : +props.data.urlzPL < 0 ? "tomato_red" : "")}>
					<p>
						<span className="rupy">₹</span>
						{toINR(props.data.urlzPL, 2)}
					</p>
				</div>
				{/* tomato_red kelly_green */}
				<div className={"col ttl_mtm robM taRight " + (+props.data.mtm > 0 ? "kelly_green" : +props.data.mtm < 0 ? "tomato_red" : "")}>
					<p>
						<span className="rupy">₹</span>
						{toINR(props.data.mtm, 2)}
					</p>
				</div>
				<div className="col opn_tag">
					<span>
						<Tag
							value={props.data.sqOff !== "false" ? "open" : "closed"}
							shape="chip"
							color={props.data.sqOff !== "false" ? "blue" : "green"}
						/>
					</span>
				</div>
				{handleDevice.isDesktop && !props.isSelectEnable && (
					<>
						<div className="col sq_off">{props.data.sqOff !== "false" && <a href=".">Sq.off</a>}</div>
						<div className="col add">
							<a href="/">Add</a>
						</div>
					</>
				)}
				{handleDevice.isTablet && !props.isSelectEnable && (
					<div className="col menu">
						<OverflowButton dropdownOptions={dropdownOptions} onSelect={(id, data) => console.log(id, data)} />
					</div>
				)}
			</div>
			<div className="panel_txt">
				<div className="left_sec ib">
					<div className="data">
						<span className="txt ib">Realised MTM</span>
						<span className="val ib">
							<span className="rupy">₹</span>
							{toINR(props.data.rlzPL, 2)}
						</span>
					</div>
					{/* <div className="data pd-t10">
						<span className="txt ib">Exposure</span>
						<span className="val ib">
							<span className="rupy">₹</span>₹99,271.60
						</span>
					</div> */}
				</div>
				<div className="qty_sec ib">
					<div className="data">
						<span className="txt ib">Buy Qty:</span>
						<span className="val ib">
							{props.data.byQty} <br />
							<i className="at_icon">@</i> <span className="rupy">₹</span>
							{toINR(props.data.byAmt, 2)}
						</span>
					</div>
					<div className="data pd-t10">
						<span className="txt ib">Sell Qty:</span>
						<span className="val ib">
							{props.data.slQty}
							<br />
							<i className="at_icon">@</i> <span className="rupy">₹</span>
							{toINR(props.data.slAmt, 2)}
						</span>
					</div>
				</div>
				{handleDevice.isTablet && (
					<div className="right_sec ib">
						<button className="sqr_btn btn">Square-off</button>
						<button className="add_btn btn">Add more</button>
					</div>
				)}
			</div>
		</li>
	);
};

export default PositionTblRowDesk;
